<template>
    <v-card flat class="mb-10">
        <div
            class="d-flex align-center justify-space-between px-3 pt-3 font-weight-600 font-size-18 border-bottom pb-3 mt-5"
        >
            <div>Data Aktivitas Konsul</div>
        </div>

        <div class="d-flex px-3 py-4 gap-10 border-bottom">
            <v-select
                v-model="search_category"
                :items="filter"
                item-text="label"
                item-value="value"
                placeholder="Filter"
                outlined
                dense
                hide-details
                style="max-width: 20%"
            ></v-select>

            <v-text-field
                v-model="search_value"
                placeholder="Ketik kata kunci dan tekan enter"
                dense
                outlined
                small
                hide-details
                append-icon="mdi-magnify"
                @keyup.enter="onSearchData(1)"
            ></v-text-field>

            <v-select
                v-model="search_sort_by"
                :items="sort_by"
                item-text="label"
                item-value="value"
                placeholder="Sort By"
                outlined
                dense
                hide-details
                style="max-width: 15%"
                @change="onSearchData(1)"
            ></v-select>

            <v-select
                v-model="search_sort_type"
                :items="sort_type"
                item-text="label"
                item-value="value"
                placeholder="Sort Type"
                outlined
                dense
                hide-details
                style="max-width: 15%"
                @change="onSearchData(1)"
            ></v-select>
        </div>

        <v-data-table
            v-model="datatable"
            :headers="headers"
            :items="data"
            item-key="id"
            :loading="loading"
            :server-items-length="totalItems"
            :items-per-page="itemsPerPage"
            :footer-props="{
                'items-per-page-options': [10, 20],
            }"
            :page="page"
            @update:page="onSearchData"
            @update:items-per-page="onUpdatePerPages"
            no-data-text="Data konsultan tidak tersedia"
        >
            <template v-slot:item.action="{ item }">
                <v-menu offset-y transition="slide-y-transition">
                    <template v-slot:activator="{ on }">
                        <v-btn text v-on="on">
                            <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                    </template>
                    <v-card>
                        <v-list>
                            <v-list-item-group>
                                <v-list-item v-on:click="openDetail(item)">
                                    <v-list-item-title
                                        class="d-flex align-center gap-10"
                                    >
                                        <v-icon color="blew" class="menu-icon">
                                            mdi-forum
                                        </v-icon>
                                        Detail Konsul
                                    </v-list-item-title>
                                </v-list-item>
                            </v-list-item-group>
                        </v-list>
                    </v-card>
                </v-menu>
            </template>

            <template v-slot:item.rating="{ item }">
                <div class="d-flex align-center justify-end">
                    <v-icon class="mr-1" small color="#f2af17">
                        mdi-star
                    </v-icon>
                    {{ item.rating }}
                </div>
            </template>

            <template v-slot:item.date="{ item }">
                <div>
                    {{
                        $moment(item.date)
                            .tz("Asia/Jakarta")
                            .format("YYYY-MM-DD HH:mm")
                    }}
                </div>
            </template>

            <template v-slot:item.status="{ item }">
                <v-chip
                    v-if="item.status === 'finished'"
                    class="font-weight-600"
                    small
                    color="#e2f5ea"
                    text-color="#27ae60"
                >
                    Finished
                </v-chip>

                <v-chip
                    v-if="item.status === 'accepted'"
                    class="font-weight-600"
                    small
                    color="#e2f5ea"
                    text-color="#27ae60"
                >
                    Accepted
                </v-chip>

                <v-chip
                    v-if="item.status === 'waiting'"
                    class="font-weight-600"
                    small
                >
                    Waiting
                </v-chip>

                <v-chip
                    v-if="item.status === 'started'"
                    class="font-weight-600"
                    small
                >
                    Started
                </v-chip>

                <v-chip
                    v-if="item.status === 'request'"
                    class="font-weight-600"
                    small
                    color="#e2f5ea"
                    text-color="#00cf3f"
                >
                    Request
                </v-chip>

                <v-chip
                    v-if="item.status === 'timeout'"
                    class="font-weight-600"
                    small
                    color="#fbefb2"
                    text-color="#f2af17"
                >
                    Timeout
                </v-chip>

                <v-chip
                    v-if="item.status === 'canceled'"
                    class="font-weight-600"
                    small
                    color="#ffcccf"
                    text-color="#eb3123"
                >
                    Canceled
                </v-chip>

                <v-chip
                    v-if="item.status === 'interrupted'"
                    class="font-weight-600"
                    small
                    color="#ffcccf"
                    text-color="#eb3123"
                >
                    Interrupted
                </v-chip>
            </template>

            <template v-slot:no-results>
                <div class="text-center">
                    <p class="my-2">Hasil pencarian tidak ditemukan.</p>
                </div>
            </template>
        </v-data-table>

        <v-dialog v-model="dialogDetail" max-width="600" scrollable>
            <consul-activity-detail
                v-if="dialogDetail"
                :detail="detail"
                @close="dialogDetail = false"
            />
        </v-dialog>

        <!-- <app-spinner v-if="loading" /> -->
    </v-card>
</template>

<script>
import ConsulActivityDetail from "./ConsulActivityDetail.vue";
import axios from "axios";
import moment from "moment-timezone";
import AppSpinner from "@/modules/global/components/plugins/Spinner";

export default {
    name: "consultant-management-table",

    components: {
        ConsulActivityDetail,
        AppSpinner,
    },

    data() {
        return {
            loading: false,
            datatable: null,
            data: [],
            search_category: null,
            search_value: null,
            search_sort_by: null,
            search_sort_type: null,
            headers: [
                { text: "Aksi", value: "action", sortable: false, width: 100 },
                {
                    text: "Student",
                    value: "student_name",
                    sortable: false,
                    width: 180,
                },
                { text: "Konsultan", value: "teacher_name", width: 180 },
                { text: "Mata Pelajaran", value: "subject_name", width: 150 },
                {
                    text: "Tanggal",
                    value: "date",
                    sortable: false,
                    width: 150,
                },
                {
                    text: "Status Konsultasi",
                    value: "status",
                    sortable: false,
                    align: "center",
                    width: 130,
                },
                {
                    text: "Waktu Efektif",
                    value: "total_active_time",
                    sortable: false,
                    align: "right",
                    width: 120,
                },
                {
                    text: "Jumlah Sesi",
                    value: "total_session",
                    sortable: false,
                    align: "right",
                    width: 100,
                },
                {
                    text: "Rating",
                    value: "rating",
                    sortable: false,
                    align: "right",
                    width: 100,
                },
            ],
            data: [],
            filter: [
                {
                    value: "teacher_name",
                    label: "Nama Teacher",
                },
                {
                    value: "student_name",
                    label: "Nama Siswa",
                },
                {
                    value: "subject",
                    label: "Mapel",
                },
                {
                    value: "grade",
                    label: "Kelas",
                },
                {
                    value: "status",
                    label: "Status",
                },
            ],
            sort_by: [
                {
                    value: "createdAt",
                    label: "Created Date",
                },
            ],

            sort_type: [
                {
                    value: "asc",
                    label: "Lama ke Baru",
                },
                {
                    value: "desc",
                    label: "Baru ke Lama",
                },
            ],
            params: {
                page: 1,
                limit: 10,
                sort_by: null,
                sort_type: null,
            },
            totalItems: 0,
            itemsPerPage: 10,
            page: 1,
            dialogDetail: false,
            detail: {},
        };
    },

    mounted() {
        this.fetchData();
    },

    watch: {},

    methods: {
        onUpdatePerPages(val) {
            this.itemsPerPage = val;
            this.onSearchData(1);
        },

        onSearchData(newPage) {
            this.params = {
                page: newPage || 1,
                limit: this.itemsPerPage || 0,
                sort_by: this.search_sort_by || null,
                sort_type: this.search_sort_type || null,
                // date_from: "",
                // date_to: ""
            };

            this.params[this.search_category] = this.search_value;
            this.page = newPage;

            this.fetchData();
        },

        fetchData() {
            const url = `${process.env.API_BASE_URL}konsul/admin/list-konsul`;
            const authToken = JSON.parse(localStorage.getItem("token")).value;
            const options = {
                headers: {
                    Authorization: "Bearer " + authToken,
                },
            };

            const self = this;
            self.loading = true;

            axios
                .get(url, {
                    params: this.params,
                    ...options,
                })
                .then(function (response) {
                    self.data = response.data.list_report || [];
                    self.totalItems = response.data.total_item || 0;
                })
                .finally(() => {
                    self.loading = false;
                });
        },

        openDetail(data) {
            const url = `${process.env.API_BASE_URL}konsul/admin/${data.id}/konsul`;
            const authToken = JSON.parse(localStorage.getItem("token")).value;
            const options = {
                headers: {
                    Authorization: "Bearer " + authToken,
                },
            };

            const self = this;

            axios
                .get(url, options)
                .then(function (response) {
                    self.dialogDetail = true;
                    self.detail = response.data;
                })
                .catch(() => {
                    self.detail = {};
                    self.messages = [];
                });
        },
    },
};
</script>



// WEBPACK FOOTER //
// ConsulActivityTable.vue?342fdd66